import { render, staticRenderFns } from "./LogItem.vue?vue&type=template&id=288f2166&scoped=true&"
import script from "./LogItem.vue?vue&type=script&lang=js&"
export * from "./LogItem.vue?vue&type=script&lang=js&"
import style0 from "./LogItem.vue?vue&type=style&index=0&id=288f2166&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288f2166",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardSubtitle,VCardText})
